function loadImage(source) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("图片读取失败"));
    image.src = source;
  });
}

function canvasToDataUrl(canvas, type, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error("缩略图生成失败"));
        return;
      }
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ""));
      reader.onerror = () => reject(new Error("缩略图读取失败"));
      reader.readAsDataURL(blob);
    }, type, quality);
  });
}

/** 为作品列表生成独立缩略图；失败时返回原图，避免阻断发布。 */
export async function createWorkThumbnail(source, options = {}) {
  if (!source || !String(source).startsWith("data:image/")) return source || "";
  const maxEdge = Math.max(240, Number(options.maxEdge) || 720);
  const quality = Math.max(0.5, Math.min(0.95, Number(options.quality) || 0.82));
  try {
    const image = await loadImage(source);
    const scale = Math.min(1, maxEdge / Math.max(image.naturalWidth, image.naturalHeight));
    const width = Math.max(1, Math.round(image.naturalWidth * scale));
    const height = Math.max(1, Math.round(image.naturalHeight * scale));
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d", { alpha: true });
    if (!context) return source;
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";
    context.drawImage(image, 0, 0, width, height);
    const thumbnail = await canvasToDataUrl(canvas, "image/webp", quality);
    return thumbnail.length < source.length ? thumbnail : source;
  } catch (error) {
    return source;
  }
}
